export default __webpack_public_path__ + "static/media/38.71be4f7a.jpg";